import { systemToComponent as t } from "@virtuoso.dev/react-urx";
import * as e from "@virtuoso.dev/urx";
import * as n from "react";
import { useLayoutEffect as r, useEffect as o, useRef as i, useCallback as a, createElement as l } from "react";
import { flushSync as s } from "react-dom";
function u() {
    return u = Object.assign || function(t) {
        for(var _$e = 1; _$e < arguments.length; _$e++){
            var _$n = arguments[_$e];
            for(var _$r in _$n)Object.prototype.hasOwnProperty.call(_$n, _$r) && (t[_$r] = _$n[_$r]);
        }
        return t;
    }, u.apply(this, arguments);
}
function c(t, e) {
    if (null == t) return {};
    var _$n, _$r, _$o = {}, i = Object.keys(t);
    for(_$r = 0; _$r < i.length; _$r++)e.indexOf(_$n = i[_$r]) >= 0 || (_$o[_$n] = t[_$n]);
    return _$o;
}
function m(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var _$n = 0, _$r = new Array(e); _$n < e; _$n++)_$r[_$n] = t[_$n];
    return _$r;
}
function d(t, e) {
    var _$n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (_$n) return (_$n = _$n.call(t)).next.bind(_$n);
    if (Array.isArray(t) || (_$n = function(t, e) {
        if (t) {
            if ("string" == typeof t) return m(t, e);
            var _$n = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === _$n && t.constructor && (_$n = t.constructor.name), "Map" === _$n || "Set" === _$n ? Array.from(t) : "Arguments" === _$n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_$n) ? m(t, e) : void 0;
        }
    }(t)) || e && t && "number" == typeof t.length) {
        _$n && (t = _$n);
        var _$r = 0;
        return function() {
            return _$r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[_$r++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var f, p, h = "undefined" != typeof document ? r : o;
!function(t) {
    t[t.DEBUG = 0] = "DEBUG", t[t.INFO = 1] = "INFO", t[t.WARN = 2] = "WARN", t[t.ERROR = 3] = "ERROR";
}(p || (p = {}));
var g = ((f = {})[p.DEBUG] = "debug", f[p.INFO] = "log", f[p.WARN] = "warn", f[p.ERROR] = "error", f), v = e.system(function() {
    var _$t = e.statefulStream(p.ERROR);
    return {
        log: e.statefulStream(function(n, r, o) {
            var i;
            void 0 === o && (o = p.INFO), o >= (null != (i = ("undefined" == typeof globalThis ? window : globalThis).VIRTUOSO_LOG_LEVEL) ? i : e.getValue(_$t)) && console[g[o]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", n, r);
        }),
        logLevel: _$t
    };
}, [], {
    singleton: !0
});
function S(t, e) {
    void 0 === e && (e = !0);
    var _$n = i(null), _$r = function r(t) {};
    if ("undefined" != typeof ResizeObserver) {
        var _$o = new ResizeObserver(function(e) {
            var _$n = e[0].target;
            null !== _$n.offsetParent && t(_$n);
        });
        _$r = function r(t) {
            t && e ? (_$o.observe(t), _$n.current = t) : (_$n.current && _$o.unobserve(_$n.current), _$n.current = null);
        };
    }
    return {
        ref: _$n,
        callbackRef: _$r
    };
}
function I(t, e) {
    return void 0 === e && (e = !0), S(t, e).callbackRef;
}
function C(t, e, n, r, o, i) {
    return S(function(n) {
        for(var a = function(t, e, n, r) {
            var _$o = t.length;
            if (0 === _$o) return null;
            for(var _$i = [], a = 0; a < _$o; a++){
                var l = t.item(a);
                if (l && void 0 !== l.dataset.index) {
                    var s = parseInt(l.dataset.index), u = parseFloat(l.dataset.knownSize), c = e(l, "offsetHeight");
                    if (0 === c && r("Zero-sized element, this should not happen", {
                        child: l
                    }, p.ERROR), c !== u) {
                        var m = _$i[_$i.length - 1];
                        0 === _$i.length || m.size !== c || m.endIndex !== s - 1 ? _$i.push({
                            startIndex: s,
                            endIndex: s,
                            size: c
                        }) : _$i[_$i.length - 1].endIndex++;
                    }
                }
            }
            return _$i;
        }(n.children, e, 0, o), l = n.parentElement; !l.dataset.virtuosoScroller;)l = l.parentElement;
        var s = i ? i.scrollTop : "window" === l.firstElementChild.dataset.viewportType ? window.pageYOffset || document.documentElement.scrollTop : l.scrollTop;
        r({
            scrollTop: Math.max(s, 0),
            scrollHeight: (null != i ? i : l).scrollHeight,
            viewportHeight: (null != i ? i : l).offsetHeight
        }), null !== a && t(a);
    }, n);
}
function T(t, e) {
    return Math.round(t.getBoundingClientRect()[e]);
}
function w(t, n, r, l, u) {
    void 0 === l && (l = e.noop);
    var c = i(null), m = i(null), d = i(null), f = i(!1), p = a(function(e) {
        var _$r = e.target, _$o = _$r === window || _$r === document ? window.pageYOffset || document.documentElement.scrollTop : _$r.scrollTop, _$i = _$r === window ? document.documentElement.scrollHeight : _$r.scrollHeight, _$a = _$r === window ? window.innerHeight : _$r.offsetHeight, _$l = function l() {
            t({
                scrollTop: Math.max(_$o, 0),
                scrollHeight: _$i,
                viewportHeight: _$a
            });
        };
        f.current ? s(_$l) : _$l(), f.current = !1, null !== m.current && (_$o === m.current || _$o <= 0 || _$o === _$r.scrollHeight - T(_$r, "height")) && (m.current = null, n(!0), d.current && (clearTimeout(d.current), d.current = null));
    }, [
        t,
        n
    ]);
    return o(function() {
        var _$t = u || c.current;
        return l(u || c.current), p({
            target: _$t
        }), _$t.addEventListener("scroll", p, {
            passive: !0
        }), function() {
            l(null), _$t.removeEventListener("scroll", p);
        };
    }, [
        c,
        p,
        r,
        l,
        u
    ]), {
        scrollerRef: c,
        scrollByCallback: function scrollByCallback(t) {
            f.current = !0, c.current.scrollBy(t);
        },
        scrollToCallback: function scrollToCallback(e) {
            var _$r = c.current;
            if (_$r && (!("offsetHeight" in _$r) || 0 !== _$r.offsetHeight)) {
                var _$o, _$i, _$a, _$l = "smooth" === e.behavior;
                if (_$r === window ? (_$i = Math.max(T(document.documentElement, "height"), document.documentElement.scrollHeight), _$o = window.innerHeight, _$a = document.documentElement.scrollTop) : (_$i = _$r.scrollHeight, _$o = T(_$r, "height"), _$a = _$r.scrollTop), e.top = Math.ceil(Math.max(Math.min(_$i - _$o, e.top), 0)), Math.abs(_$o - _$i) < 1.01 || e.top === _$a) return t({
                    scrollTop: _$a,
                    scrollHeight: _$i,
                    viewportHeight: _$o
                }), void (_$l && n(!0));
                _$l ? (m.current = e.top, d.current && clearTimeout(d.current), d.current = setTimeout(function() {
                    d.current = null, m.current = null, n(!0);
                }, 1e3)) : m.current = null, _$r.scrollTo(e);
            }
        }
    };
}
var x = e.system(function() {
    return {
        recalcInProgress: e.statefulStream(!1)
    };
}, [], {
    singleton: !0
}), y = e.system(function(t) {
    var _$n = t[0].recalcInProgress, _$r = e.stream(), _$o = e.stream(), i = e.statefulStream(0), a = e.stream(), l = e.statefulStream(0), s = e.stream(), u = e.stream(), c = e.statefulStream(0), m = e.statefulStream(0), d = e.statefulStream(0), f = e.stream(), p = e.stream(), h = e.statefulStream(!1), g = e.statefulStream(!1);
    return e.connect(e.pipe(_$o, e.mapTo(!1)), _$n), e.connect(e.pipe(_$r, e.map(function(t) {
        return t.scrollTop;
    })), _$o), e.connect(e.pipe(_$r, e.map(function(t) {
        return t.scrollHeight;
    })), u), e.connect(_$o, l), {
        scrollContainerState: _$r,
        scrollTop: _$o,
        viewportHeight: s,
        headerHeight: c,
        fixedHeaderHeight: m,
        footerHeight: d,
        scrollHeight: u,
        smoothScrollTargetReached: a,
        react18ConcurrentRendering: g,
        scrollTo: f,
        scrollBy: p,
        statefulScrollTop: l,
        deviation: i,
        scrollingInProgress: h
    };
}, e.tup(x), {
    singleton: !0
}), b = {
    lvl: 0
};
function E(t, e, n, r, o) {
    return void 0 === r && (r = b), void 0 === o && (o = b), {
        k: t,
        v: e,
        lvl: n,
        l: r,
        r: o
    };
}
function H(t) {
    return t === b;
}
function R() {
    return b;
}
function L(t, e) {
    if (H(t)) return b;
    var _$n = t.k, _$r = t.l, _$o = t.r;
    if (e === _$n) {
        if (H(_$r)) return _$o;
        if (H(_$o)) return _$r;
        var i = P(_$r);
        return U(M(t, {
            k: i[0],
            v: i[1],
            l: O(_$r)
        }));
    }
    return U(M(t, e < _$n ? {
        l: L(_$r, e)
    } : {
        r: L(_$o, e)
    }));
}
function k(t, e, n) {
    if (void 0 === n && (n = "k"), H(t)) return [
        -Infinity,
        void 0
    ];
    if (t[n] === e) return [
        t.k,
        t.v
    ];
    if (t[n] < e) {
        var _$r = k(t.r, e, n);
        return -Infinity === _$r[0] ? [
            t.k,
            t.v
        ] : _$r;
    }
    return k(t.l, e, n);
}
function z(t, e, n) {
    return H(t) ? E(e, n, 1) : e === t.k ? M(t, {
        k: e,
        v: n
    }) : function(t) {
        return N(D(t));
    }(M(t, e < t.k ? {
        l: z(t.l, e, n)
    } : {
        r: z(t.r, e, n)
    }));
}
function B(t, e, n) {
    if (H(t)) return [];
    var _$r = t.k, _$o = t.v, i = t.r, a = [];
    return _$r > e && (a = a.concat(B(t.l, e, n))), _$r >= e && _$r <= n && a.push({
        k: _$r,
        v: _$o
    }), _$r <= n && (a = a.concat(B(i, e, n))), a;
}
function F(t) {
    return H(t) ? [] : [].concat(F(t.l), [
        {
            k: t.k,
            v: t.v
        }
    ], F(t.r));
}
function P(t) {
    return H(t.r) ? [
        t.k,
        t.v
    ] : P(t.r);
}
function O(t) {
    return H(t.r) ? t.l : U(M(t, {
        r: O(t.r)
    }));
}
function M(t, e) {
    return E(void 0 !== e.k ? e.k : t.k, void 0 !== e.v ? e.v : t.v, void 0 !== e.lvl ? e.lvl : t.lvl, void 0 !== e.l ? e.l : t.l, void 0 !== e.r ? e.r : t.r);
}
function V(t) {
    return H(t) || t.lvl > t.r.lvl;
}
function U(t) {
    var _$e = t.l, _$n = t.r, _$r = t.lvl;
    if (_$n.lvl >= _$r - 1 && _$e.lvl >= _$r - 1) return t;
    if (_$r > _$n.lvl + 1) {
        if (V(_$e)) return D(M(t, {
            lvl: _$r - 1
        }));
        if (H(_$e) || H(_$e.r)) throw new Error("Unexpected empty nodes");
        return M(_$e.r, {
            l: M(_$e, {
                r: _$e.r.l
            }),
            r: M(t, {
                l: _$e.r.r,
                lvl: _$r - 1
            }),
            lvl: _$r
        });
    }
    if (V(t)) return N(M(t, {
        lvl: _$r - 1
    }));
    if (H(_$n) || H(_$n.l)) throw new Error("Unexpected empty nodes");
    var _$o = _$n.l, i = V(_$o) ? _$n.lvl - 1 : _$n.lvl;
    return M(_$o, {
        l: M(t, {
            r: _$o.l,
            lvl: _$r - 1
        }),
        r: N(M(_$n, {
            l: _$o.r,
            lvl: i
        })),
        lvl: _$o.lvl + 1
    });
}
function A(t, e, n) {
    return H(t) ? [] : W(B(t, k(t, e)[0], n), function(t) {
        return {
            index: t.k,
            value: t.v
        };
    });
}
function W(t, e) {
    var _$n = t.length;
    if (0 === _$n) return [];
    for(var _$r = e(t[0]), _$o = _$r.index, i = _$r.value, a = [], l = 1; l < _$n; l++){
        var s = e(t[l]), u = s.index, c = s.value;
        a.push({
            start: _$o,
            end: u - 1,
            value: i
        }), _$o = u, i = c;
    }
    return a.push({
        start: _$o,
        end: Infinity,
        value: i
    }), a;
}
function N(t) {
    var _$e = t.r, _$n = t.lvl;
    return H(_$e) || H(_$e.r) || _$e.lvl !== _$n || _$e.r.lvl !== _$n ? t : M(_$e, {
        l: M(t, {
            r: _$e.l
        }),
        lvl: _$n + 1
    });
}
function D(t) {
    var _$e = t.l;
    return H(_$e) || _$e.lvl !== t.lvl ? t : M(_$e, {
        r: M(t, {
            l: _$e.r
        })
    });
}
function G(t, e, n, r) {
    void 0 === r && (r = 0);
    for(var _$o = t.length - 1; r <= _$o;){
        var i = Math.floor((r + _$o) / 2), a = n(t[i], e);
        if (0 === a) return i;
        if (-1 === a) {
            if (_$o - r < 2) return i - 1;
            _$o = i - 1;
        } else {
            if (_$o === r) return i;
            r = i + 1;
        }
    }
    throw new Error("Failed binary finding record in array - " + t.join(",") + ", searched for " + e);
}
function _(t, e, n) {
    return t[G(t, e, n)];
}
function j(t) {
    var _$e = t.size, _$n = t.startIndex, _$r = t.endIndex;
    return function(t) {
        return t.start === _$n && (t.end === _$r || Infinity === t.end) && t.value === _$e;
    };
}
function K(t, e) {
    var _$n = t.index;
    return e === _$n ? 0 : e < _$n ? -1 : 1;
}
function Y(t, e) {
    var _$n = t.offset;
    return e === _$n ? 0 : e < _$n ? -1 : 1;
}
function Z(t) {
    return {
        index: t.index,
        value: t
    };
}
function q(t, e, n) {
    var _$r = t, _$o = 0, i = 0, a = 0, l = 0;
    if (0 !== e) {
        a = _$r[l = G(_$r, e - 1, K)].offset;
        var s = k(n, e - 1);
        _$o = s[0], i = s[1], _$r.length && _$r[l].size === k(n, e)[1] && (l -= 1), _$r = _$r.slice(0, l + 1);
    } else _$r = [];
    for(var u, c = d(A(n, e, Infinity)); !(u = c()).done;){
        var m = u.value, f = m.start, p = m.value, h = (f - _$o) * i + a;
        _$r.push({
            offset: h,
            size: p,
            index: f
        }), _$o = f, a = h, i = p;
    }
    return {
        offsetTree: _$r,
        lastIndex: _$o,
        lastOffset: a,
        lastSize: i
    };
}
function J(t, e) {
    var _$n = e[0], _$r = e[1];
    _$n.length > 0 && (0, e[2])("received item sizes", _$n, p.DEBUG);
    var _$o = t.sizeTree, i = _$o, a = 0;
    if (_$r.length > 0 && H(_$o) && 2 === _$n.length) {
        var l = _$n[0].size, s = _$n[1].size;
        i = _$r.reduce(function(t, e) {
            return z(z(t, e, l), e + 1, s);
        }, i);
    } else {
        var u = function(t, e) {
            for(var _$n, _$r = H(t) ? 0 : Infinity, _$o = d(e); !(_$n = _$o()).done;){
                var i = _$n.value, a = i.size, l = i.startIndex, s = i.endIndex;
                if (_$r = Math.min(_$r, l), H(t)) t = z(t, 0, a);
                else {
                    var u = A(t, l - 1, s + 1);
                    if (!u.some(j(i))) {
                        for(var c, m = !1, f = !1, p = d(u); !(c = p()).done;){
                            var h = c.value, g = h.start, v = h.end, S = h.value;
                            m ? (s >= g || a === S) && (t = L(t, g)) : (f = S !== a, m = !0), v > s && s >= g && S !== a && (t = z(t, s + 1, S));
                        }
                        f && (t = z(t, l, a));
                    }
                }
            }
            return [
                t,
                _$r
            ];
        }(i, _$n);
        i = u[0], a = u[1];
    }
    if (i === _$o) return t;
    var c = q(t.offsetTree, a, i), m = c.offsetTree;
    return {
        sizeTree: i,
        offsetTree: m,
        lastIndex: c.lastIndex,
        lastOffset: c.lastOffset,
        lastSize: c.lastSize,
        groupOffsetTree: _$r.reduce(function(t, e) {
            return z(t, e, $(e, m));
        }, R()),
        groupIndices: _$r
    };
}
function $(t, e) {
    if (0 === e.length) return 0;
    var _$n = _(e, t, K);
    return _$n.size * (t - _$n.index) + _$n.offset;
}
function Q(t, e, n) {
    if (function(t) {
        return void 0 !== t.groupIndex;
    }(t)) return e.groupIndices[t.groupIndex] + 1;
    var _$r = X("LAST" === t.index ? n : t.index, e);
    return Math.max(0, _$r, Math.min(n, _$r));
}
function X(t, e) {
    if (!tt(e)) return t;
    for(var _$n = 0; e.groupIndices[_$n] <= t + _$n;)_$n++;
    return t + _$n;
}
function tt(t) {
    return !H(t.groupOffsetTree);
}
var et = {
    offsetHeight: "height",
    offsetWidth: "width"
}, nt = e.system(function(t) {
    var _$n = t[0].log, _$r = t[1].recalcInProgress, _$o = e.stream(), i = e.stream(), a = e.statefulStreamFromEmitter(i, 0), l = e.stream(), s = e.stream(), c = e.statefulStream(0), m = e.statefulStream([]), d = e.statefulStream(void 0), f = e.statefulStream(void 0), h = e.statefulStream(function(t, e) {
        return T(t, et[e]);
    }), g = e.statefulStream(void 0), v = {
        offsetTree: [],
        sizeTree: R(),
        groupOffsetTree: R(),
        lastIndex: 0,
        lastOffset: 0,
        lastSize: 0,
        groupIndices: []
    }, S = e.statefulStreamFromEmitter(e.pipe(_$o, e.withLatestFrom(m, _$n), e.scan(J, v), e.distinctUntilChanged()), v);
    e.connect(e.pipe(m, e.filter(function(t) {
        return t.length > 0;
    }), e.withLatestFrom(S), e.map(function(t) {
        var _$e = t[0], _$n = t[1], _$r = _$e.reduce(function(t, e, r) {
            return z(t, e, $(e, _$n.offsetTree) || r);
        }, R());
        return u({}, _$n, {
            groupIndices: _$e,
            groupOffsetTree: _$r
        });
    })), S), e.connect(e.pipe(i, e.withLatestFrom(S), e.filter(function(t) {
        return t[0] < t[1].lastIndex;
    }), e.map(function(t) {
        var _$e = t[1];
        return [
            {
                startIndex: t[0],
                endIndex: _$e.lastIndex,
                size: _$e.lastSize
            }
        ];
    })), _$o), e.connect(d, f);
    var I = e.statefulStreamFromEmitter(e.pipe(d, e.map(function(t) {
        return void 0 === t;
    })), !0);
    e.connect(e.pipe(f, e.filter(function(t) {
        return void 0 !== t && H(e.getValue(S).sizeTree);
    }), e.map(function(t) {
        return [
            {
                startIndex: 0,
                endIndex: 0,
                size: t
            }
        ];
    })), _$o);
    var C = e.streamFromEmitter(e.pipe(_$o, e.withLatestFrom(S), e.scan(function(t, e) {
        var _$n = e[1];
        return {
            changed: _$n !== t.sizes,
            sizes: _$n
        };
    }, {
        changed: !1,
        sizes: v
    }), e.map(function(t) {
        return t.changed;
    })));
    e.subscribe(e.pipe(c, e.scan(function(t, e) {
        return {
            diff: t.prev - e,
            prev: e
        };
    }, {
        diff: 0,
        prev: 0
    }), e.map(function(t) {
        return t.diff;
    })), function(t) {
        t > 0 ? (e.publish(_$r, !0), e.publish(l, t)) : t < 0 && e.publish(s, t);
    }), e.subscribe(e.pipe(c, e.withLatestFrom(_$n)), function(t) {
        t[0] < 0 && (0, t[1])("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
            firstItemIndex: c
        }, p.ERROR);
    });
    var w = e.streamFromEmitter(l);
    e.connect(e.pipe(l, e.withLatestFrom(S), e.map(function(t) {
        var _$e = t[0], _$n = t[1];
        if (_$n.groupIndices.length > 0) throw new Error("Virtuoso: prepending items does not work with groups");
        return F(_$n.sizeTree).reduce(function(t, n) {
            var _$r = n.k, _$o = n.v;
            return {
                ranges: [].concat(t.ranges, [
                    {
                        startIndex: t.prevIndex,
                        endIndex: _$r + _$e - 1,
                        size: t.prevSize
                    }
                ]),
                prevIndex: _$r + _$e,
                prevSize: _$o
            };
        }, {
            ranges: [],
            prevIndex: 0,
            prevSize: _$n.lastSize
        }).ranges;
    })), _$o);
    var x = e.streamFromEmitter(e.pipe(s, e.withLatestFrom(S), e.map(function(t) {
        return $(-t[0], t[1].offsetTree);
    })));
    return e.connect(e.pipe(s, e.withLatestFrom(S), e.map(function(t) {
        var _$e = t[0], _$n = t[1];
        if (_$n.groupIndices.length > 0) throw new Error("Virtuoso: shifting items does not work with groups");
        var _$r = F(_$n.sizeTree).reduce(function(t, n) {
            var _$r = n.v;
            return z(t, Math.max(0, n.k + _$e), _$r);
        }, R());
        return u({}, _$n, {
            sizeTree: _$r
        }, q(_$n.offsetTree, 0, _$r));
    })), S), {
        data: g,
        totalCount: i,
        sizeRanges: _$o,
        groupIndices: m,
        defaultItemSize: f,
        fixedItemSize: d,
        unshiftWith: l,
        shiftWith: s,
        shiftWithOffset: x,
        beforeUnshiftWith: w,
        firstItemIndex: c,
        sizes: S,
        listRefresh: C,
        statefulTotalCount: a,
        trackItemSizes: I,
        itemSize: h
    };
}, e.tup(v, x), {
    singleton: !0
}), rt = "undefined" != typeof document && "scrollBehavior" in document.documentElement.style;
function ot(t) {
    var _$e = "number" == typeof t ? {
        index: t
    } : t;
    return _$e.align || (_$e.align = "start"), _$e.behavior && rt || (_$e.behavior = "auto"), _$e.offset || (_$e.offset = 0), _$e;
}
var it = e.system(function(t) {
    var _$n = t[0], _$r = _$n.sizes, _$o = _$n.totalCount, i = _$n.listRefresh, a = t[1], l = a.scrollingInProgress, s = a.viewportHeight, u = a.scrollTo, c = a.smoothScrollTargetReached, m = a.headerHeight, d = a.footerHeight, f = t[2].log, h = e.stream(), g = e.statefulStream(0), v = null, S = null, I = null;
    function C() {
        v && (v(), v = null), I && (I(), I = null), S && (clearTimeout(S), S = null), e.publish(l, !1);
    }
    return e.connect(e.pipe(h, e.withLatestFrom(_$r, s, _$o, g, m, d, f), e.map(function(t) {
        var _$n = t[0], _$r = t[1], _$o = t[2], a = t[3], s = t[4], u = t[5], m = t[6], d = t[7], f = ot(_$n), g = f.align, T = f.behavior, w = f.offset, x = a - 1, y = Q(f, _$r, x), b = $(y, _$r.offsetTree) + u;
        "end" === g ? (b = b - _$o + k(_$r.sizeTree, y)[1], y === x && (b += m)) : "center" === g ? b = b - _$o / 2 + k(_$r.sizeTree, y)[1] / 2 : b -= s, w && (b += w);
        var E = function E(t) {
            C(), t ? (d("retrying to scroll to", {
                location: _$n
            }, p.DEBUG), e.publish(h, _$n)) : d("list did not change, scroll successful", {}, p.DEBUG);
        };
        if (C(), "smooth" === T) {
            var H = !1;
            I = e.subscribe(i, function(t) {
                H = H || t;
            }), v = e.handleNext(c, function() {
                E(H);
            });
        } else v = e.handleNext(e.pipe(i, function(t) {
            var _$e = setTimeout(function() {
                t(!1);
            }, 50);
            return function(n) {
                n && (t(!0), clearTimeout(_$e));
            };
        }), E);
        return S = setTimeout(function() {
            C();
        }, 1200), e.publish(l, !0), d("scrolling from index to", {
            index: y,
            top: b,
            behavior: T
        }, p.DEBUG), {
            top: b,
            behavior: T
        };
    })), u), {
        scrollToIndex: h,
        topListHeight: g
    };
}, e.tup(nt, y, v), {
    singleton: !0
}), at = "up", lt = {
    atBottom: !1,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
        offsetBottom: 0,
        scrollTop: 0,
        viewportHeight: 0,
        scrollHeight: 0
    }
}, st = e.system(function(t) {
    var _$n = t[0], _$r = _$n.scrollContainerState, _$o = _$n.scrollTop, i = _$n.viewportHeight, a = _$n.headerHeight, l = _$n.footerHeight, s = _$n.scrollBy, u = e.statefulStream(!1), c = e.statefulStream(!0), m = e.stream(), d = e.stream(), f = e.statefulStream(4), p = e.statefulStream(0), h = e.statefulStreamFromEmitter(e.pipe(e.merge(e.pipe(e.duc(_$o), e.skip(1), e.mapTo(!0)), e.pipe(e.duc(_$o), e.skip(1), e.mapTo(!1), e.debounceTime(100))), e.distinctUntilChanged()), !1), g = e.statefulStreamFromEmitter(e.pipe(e.merge(e.pipe(s, e.mapTo(!0)), e.pipe(s, e.mapTo(!1), e.debounceTime(200))), e.distinctUntilChanged()), !1);
    e.connect(e.pipe(e.combineLatest(e.duc(_$o), e.duc(p)), e.map(function(t) {
        return t[0] <= t[1];
    }), e.distinctUntilChanged()), c), e.connect(e.pipe(c, e.throttleTime(50)), d);
    var v = e.streamFromEmitter(e.pipe(e.combineLatest(_$r, e.duc(i), e.duc(a), e.duc(l), e.duc(f)), e.scan(function(t, e) {
        var _$n, _$r, _$o = e[0], i = _$o.scrollTop, a = _$o.scrollHeight, l = e[1], s = {
            viewportHeight: l,
            scrollTop: i,
            scrollHeight: a
        };
        return i + l - a > -e[4] ? (i > t.state.scrollTop ? (_$n = "SCROLLED_DOWN", _$r = t.state.scrollTop - i) : (_$n = "SIZE_DECREASED", _$r = t.state.scrollTop - i || t.scrollTopDelta), {
            atBottom: !0,
            state: s,
            atBottomBecause: _$n,
            scrollTopDelta: _$r
        }) : {
            atBottom: !1,
            notAtBottomBecause: s.scrollHeight > t.state.scrollHeight ? "SIZE_INCREASED" : l < t.state.viewportHeight ? "VIEWPORT_HEIGHT_DECREASING" : i < t.state.scrollTop ? "SCROLLING_UPWARDS" : "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM",
            state: s
        };
    }, lt), e.distinctUntilChanged(function(t, e) {
        return t && t.atBottom === e.atBottom;
    }))), S = e.statefulStreamFromEmitter(e.pipe(_$r, e.scan(function(t, e) {
        var _$n = e.scrollTop, _$r = e.scrollHeight;
        return t.scrollHeight !== _$r ? t.scrollTop !== _$n && _$n === _$r - e.viewportHeight ? {
            scrollHeight: _$r,
            scrollTop: _$n,
            jump: t.scrollTop - _$n,
            changed: !0
        } : {
            scrollHeight: _$r,
            scrollTop: _$n,
            jump: 0,
            changed: !0
        } : {
            scrollTop: _$n,
            scrollHeight: _$r,
            jump: 0,
            changed: !1
        };
    }, {
        scrollHeight: 0,
        jump: 0,
        scrollTop: 0,
        changed: !1
    }), e.filter(function(t) {
        return t.changed;
    }), e.map(function(t) {
        return t.jump;
    })), 0);
    e.connect(e.pipe(v, e.map(function(t) {
        return t.atBottom;
    })), u), e.connect(e.pipe(u, e.throttleTime(50)), m);
    var I = e.statefulStream("down");
    e.connect(e.pipe(_$r, e.map(function(t) {
        return t.scrollTop;
    }), e.distinctUntilChanged(), e.scan(function(t, n) {
        return e.getValue(g) ? {
            direction: t.direction,
            prevScrollTop: n
        } : {
            direction: n < t.prevScrollTop ? at : "down",
            prevScrollTop: n
        };
    }, {
        direction: "down",
        prevScrollTop: 0
    }), e.map(function(t) {
        return t.direction;
    })), I), e.connect(e.pipe(_$r, e.throttleTime(50), e.mapTo("none")), I);
    var C = e.statefulStream(0);
    return e.connect(e.pipe(h, e.filter(function(t) {
        return !t;
    }), e.mapTo(0)), C), e.connect(e.pipe(_$o, e.throttleTime(100), e.withLatestFrom(h), e.filter(function(t) {
        return !!t[1];
    }), e.scan(function(t, e) {
        return [
            t[1],
            e[0]
        ];
    }, [
        0,
        0
    ]), e.map(function(t) {
        return t[1] - t[0];
    })), C), {
        isScrolling: h,
        isAtTop: c,
        isAtBottom: u,
        atBottomState: v,
        atTopStateChange: d,
        atBottomStateChange: m,
        scrollDirection: I,
        atBottomThreshold: f,
        atTopThreshold: p,
        scrollVelocity: C,
        lastJumpDueToItemResize: S
    };
}, e.tup(y)), ut = e.system(function(t) {
    var _$n = t[0].log, _$r = e.statefulStream(!1), _$o = e.streamFromEmitter(e.pipe(_$r, e.filter(function(t) {
        return t;
    }), e.distinctUntilChanged()));
    return e.subscribe(_$r, function(t) {
        t && e.getValue(_$n)("props updated", {}, p.DEBUG);
    }), {
        propsReady: _$r,
        didMount: _$o
    };
}, e.tup(v), {
    singleton: !0
}), ct = e.system(function(t) {
    var _$n = t[0], _$r = _$n.sizes, _$o = _$n.listRefresh, i = _$n.defaultItemSize, a = t[1].scrollTop, l = t[2].scrollToIndex, s = t[3].didMount, u = e.statefulStream(!0), c = e.statefulStream(0);
    return e.connect(e.pipe(s, e.withLatestFrom(c), e.filter(function(t) {
        return !!t[1];
    }), e.mapTo(!1)), u), e.subscribe(e.pipe(e.combineLatest(_$o, s), e.withLatestFrom(u, _$r, i), e.filter(function(t) {
        var _$e = t[1], _$n = t[3];
        return t[0][1] && (!H(t[2].sizeTree) || void 0 !== _$n) && !_$e;
    }), e.withLatestFrom(c)), function(t) {
        var _$n = t[1];
        setTimeout(function() {
            e.handleNext(a, function() {
                e.publish(u, !0);
            }), e.publish(l, _$n);
        });
    }), {
        scrolledToInitialItem: u,
        initialTopMostItemIndex: c
    };
}, e.tup(nt, y, it, ut), {
    singleton: !0
});
function mt(t) {
    return !!t && ("smooth" === t ? "smooth" : "auto");
}
var dt = e.system(function(t) {
    var _$n = t[0], _$r = _$n.totalCount, _$o = _$n.listRefresh, i = t[1], a = i.isAtBottom, l = i.atBottomState, s = t[2].scrollToIndex, u = t[3].scrolledToInitialItem, c = t[4], m = c.propsReady, d = c.didMount, f = t[5].log, h = t[6].scrollingInProgress, g = e.statefulStream(!1), v = null;
    function S(t) {
        e.publish(s, {
            index: "LAST",
            align: "end",
            behavior: t
        });
    }
    return e.subscribe(e.pipe(e.combineLatest(e.pipe(e.duc(_$r), e.skip(1)), d), e.withLatestFrom(e.duc(g), a, u, h), e.map(function(t) {
        var _$e = t[0], _$n = _$e[0], _$r = _$e[1] && t[3], _$o = "auto";
        return _$r && (_$o = function(t, e) {
            return "function" == typeof t ? mt(t(e)) : e && mt(t);
        }(t[1], t[2] || t[4]), _$r = _$r && !!_$o), {
            totalCount: _$n,
            shouldFollow: _$r,
            followOutputBehavior: _$o
        };
    }), e.filter(function(t) {
        return t.shouldFollow;
    })), function(t) {
        var _$n = t.totalCount, _$r = t.followOutputBehavior;
        v && (v(), v = null), v = e.handleNext(_$o, function() {
            e.getValue(f)("following output to ", {
                totalCount: _$n
            }, p.DEBUG), S(_$r), v = null;
        });
    }), e.subscribe(e.pipe(e.combineLatest(e.duc(g), _$r, m), e.filter(function(t) {
        return t[0] && t[2];
    }), e.scan(function(t, e) {
        var _$n = e[1];
        return {
            refreshed: t.value === _$n,
            value: _$n
        };
    }, {
        refreshed: !1,
        value: 0
    }), e.filter(function(t) {
        return t.refreshed;
    }), e.withLatestFrom(g, _$r)), function(t) {
        var _$n = t[1], _$r = e.handleNext(l, function(t) {
            !_$n || t.atBottom || "SIZE_INCREASED" !== t.notAtBottomBecause || v || (e.getValue(f)("scrolling to bottom due to increased size", {}, p.DEBUG), S("auto"));
        });
        setTimeout(_$r, 100);
    }), e.subscribe(e.combineLatest(e.duc(g), l), function(t) {
        var _$e = t[1];
        t[0] && !_$e.atBottom && "VIEWPORT_HEIGHT_DECREASING" === _$e.notAtBottomBecause && S("auto");
    }), {
        followOutput: g
    };
}, e.tup(nt, st, it, ct, ut, v, y));
function ft(t) {
    return t.reduce(function(t, e) {
        return t.groupIndices.push(t.totalCount), t.totalCount += e + 1, t;
    }, {
        totalCount: 0,
        groupIndices: []
    });
}
var pt = e.system(function(t) {
    var _$n = t[0], _$r = _$n.totalCount, _$o = _$n.groupIndices, i = _$n.sizes, a = t[1], l = a.scrollTop, s = a.headerHeight, u = e.stream(), c = e.stream(), m = e.streamFromEmitter(e.pipe(u, e.map(ft)));
    return e.connect(e.pipe(m, e.map(e.prop("totalCount"))), _$r), e.connect(e.pipe(m, e.map(e.prop("groupIndices"))), _$o), e.connect(e.pipe(e.combineLatest(l, i, s), e.filter(function(t) {
        return tt(t[1]);
    }), e.map(function(t) {
        return k(t[1].groupOffsetTree, Math.max(t[0] - t[2], 0), "v")[0];
    }), e.distinctUntilChanged(), e.map(function(t) {
        return [
            t
        ];
    })), c), {
        groupCounts: u,
        topItemsIndexes: c
    };
}, e.tup(nt, y));
function ht(t, e) {
    return !(!t || t[0] !== e[0] || t[1] !== e[1]);
}
function gt(t, e) {
    return !(!t || t.startIndex !== e.startIndex || t.endIndex !== e.endIndex);
}
function vt(t, e, n) {
    return "number" == typeof t ? n === at && "top" === e || "down" === n && "bottom" === e ? t : 0 : n === at ? "top" === e ? t.main : t.reverse : "bottom" === e ? t.main : t.reverse;
}
function St(t, e) {
    return "number" == typeof t ? t : t[e] || 0;
}
var It = e.system(function(t) {
    var _$n = t[0], _$r = _$n.scrollTop, _$o = _$n.viewportHeight, i = _$n.deviation, a = _$n.headerHeight, l = _$n.fixedHeaderHeight, s = e.stream(), u = e.statefulStream(0), c = e.statefulStream(0), m = e.statefulStream(0), d = e.statefulStreamFromEmitter(e.pipe(e.combineLatest(e.duc(_$r), e.duc(_$o), e.duc(a), e.duc(s, ht), e.duc(m), e.duc(u), e.duc(l), e.duc(i), e.duc(c)), e.map(function(t) {
        var _$e = t[0], _$n = t[1], _$r = t[2], _$o = t[3], i = _$o[0], a = _$o[1], l = t[4], s = t[6], u = t[7], c = t[8], m = _$e - u, d = t[5] + s, f = Math.max(_$r - m, 0), p = "none", h = St(c, "top"), g = St(c, "bottom");
        return i -= u, a += _$r + s, (i += _$r + s) > _$e + d - h && (p = at), (a -= u) < _$e - f + _$n + g && (p = "down"), "none" !== p ? [
            Math.max(m - _$r - vt(l, "top", p) - h, 0),
            m - f - s + _$n + vt(l, "bottom", p) + g
        ] : null;
    }), e.filter(function(t) {
        return null != t;
    }), e.distinctUntilChanged(ht)), [
        0,
        0
    ]);
    return {
        listBoundary: s,
        overscan: m,
        topListHeight: u,
        increaseViewportBy: c,
        visibleRange: d
    };
}, e.tup(y), {
    singleton: !0
}), Ct = {
    items: [],
    topItems: [],
    offsetTop: 0,
    offsetBottom: 0,
    top: 0,
    bottom: 0,
    topListHeight: 0,
    totalCount: 0,
    firstItemIndex: 0
};
function Tt(t, e, n) {
    if (0 === t.length) return [];
    if (!tt(e)) return t.map(function(t) {
        return u({}, t, {
            index: t.index + n,
            originalIndex: t.index
        });
    });
    for(var _$r, _$o = [], i = A(e.groupOffsetTree, t[0].index, t[t.length - 1].index), a = void 0, l = 0, s = d(t); !(_$r = s()).done;){
        var c = _$r.value;
        (!a || a.end < c.index) && (a = i.shift(), l = e.groupIndices.indexOf(a.start)), _$o.push(u({}, c.index === a.start ? {
            type: "group",
            index: l
        } : {
            index: c.index - (l + 1) + n,
            groupIndex: l
        }, {
            size: c.size,
            offset: c.offset,
            originalIndex: c.index,
            data: c.data
        }));
    }
    return _$o;
}
function wt(t, e, n, r, o) {
    var i = 0, a = 0;
    if (t.length > 0) {
        i = t[0].offset;
        var l = t[t.length - 1];
        a = l.offset + l.size;
    }
    var s = i, u = r.lastOffset + (n - r.lastIndex) * r.lastSize - a;
    return {
        items: Tt(t, r, o),
        topItems: Tt(e, r, o),
        topListHeight: e.reduce(function(t, e) {
            return e.size + t;
        }, 0),
        offsetTop: i,
        offsetBottom: u,
        top: s,
        bottom: a,
        totalCount: n,
        firstItemIndex: o
    };
}
var xt = e.system(function(t) {
    var _$n = t[0], _$r = _$n.sizes, _$o = _$n.totalCount, i = _$n.data, a = _$n.firstItemIndex, l = t[1], s = t[2], c = s.visibleRange, m = s.listBoundary, f = s.topListHeight, p = t[3], h = p.scrolledToInitialItem, g = p.initialTopMostItemIndex, v = t[4].topListHeight, S = t[5], I = t[6].didMount, C = t[7].recalcInProgress, T = e.statefulStream([]), w = e.stream();
    e.connect(l.topItemsIndexes, T);
    var x = e.statefulStreamFromEmitter(e.pipe(e.combineLatest(I, e.duc(c, ht), e.duc(_$o), e.duc(_$r), e.duc(g), h, e.duc(T), e.duc(a), i), e.withLatestFrom(C), e.filter(function(t) {
        return t[0][0] && !t[1];
    }), e.map(function(t) {
        var _$n = t[0], _$r = _$n[1], _$o = _$r[0], i = _$r[1], a = _$n[2], l = _$n[4], s = _$n[5], _$u = _$n[6], c = _$n[7], m = _$n[8], f = _$n[3], p = f.sizeTree, h = f.offsetTree;
        if (0 === a || 0 === _$o && 0 === i) return Ct;
        if (H(p)) return wt(function(t, e, n) {
            if (tt(e)) {
                var _$r = X(t, e);
                return [
                    {
                        index: k(e.groupOffsetTree, _$r)[0],
                        size: 0,
                        offset: 0
                    },
                    {
                        index: _$r,
                        size: 0,
                        offset: 0,
                        data: n && n[0]
                    }
                ];
            }
            return [
                {
                    index: t,
                    size: 0,
                    offset: 0,
                    data: n && n[0]
                }
            ];
        }(function(t, e) {
            return "number" == typeof t ? t : "LAST" === t.index ? e - 1 : t.index;
        }(l, a), f, m), [], a, f, c);
        var g = [];
        if (_$u.length > 0) for(var v, S = _$u[0], I = _$u[_$u.length - 1], C = 0, T = d(A(p, S, I)); !(v = T()).done;)for(var w = v.value, x = w.value, y = Math.max(w.start, S), b = Math.min(w.end, I), E = y; E <= b; E++)g.push({
            index: E,
            size: x,
            offset: C,
            data: m && m[E]
        }), C += x;
        if (!s) return wt([], g, a, f, c);
        var R = _$u.length > 0 ? _$u[_$u.length - 1] + 1 : 0, L = function(t, e, n, r) {
            return void 0 === r && (r = 0), r > 0 && (e = Math.max(e, _(t, r, K).offset)), W((i = n, l = G(_$o = t, e, a = Y), s = G(_$o, i, a, l), _$o.slice(l, s + 1)), Z);
            var _$o, i, a, l, s;
        }(h, _$o, i, R);
        if (0 === L.length) return null;
        var z = a - 1;
        return wt(e.tap([], function(t) {
            for(var _$e, _$n = d(L); !(_$e = _$n()).done;){
                var _$r = _$e.value, a = _$r.value, l = a.offset, s = _$r.start, _$u = a.size;
                a.offset < _$o && (l += ((s += Math.floor((_$o - a.offset) / _$u)) - _$r.start) * _$u), s < R && (l += (R - s) * _$u, s = R);
                for(var c = Math.min(_$r.end, z), f = s; f <= c && !(l >= i); f++)t.push({
                    index: f,
                    size: _$u,
                    offset: l,
                    data: m && m[f]
                }), l += _$u;
            }
        }), g, a, f, c);
    }), e.filter(function(t) {
        return null !== t;
    }), e.distinctUntilChanged()), Ct);
    return e.connect(e.pipe(i, e.filter(function(t) {
        return void 0 !== t;
    }), e.map(function(t) {
        return t.length;
    })), _$o), e.connect(e.pipe(x, e.map(e.prop("topListHeight"))), v), e.connect(v, f), e.connect(e.pipe(x, e.map(function(t) {
        return [
            t.top,
            t.bottom
        ];
    })), m), e.connect(e.pipe(x, e.map(function(t) {
        return t.items;
    })), w), u({
        listState: x,
        topItemsIndexes: T,
        endReached: e.streamFromEmitter(e.pipe(x, e.filter(function(t) {
            return t.items.length > 0;
        }), e.withLatestFrom(_$o, i), e.filter(function(t) {
            var _$e = t[0].items;
            return _$e[_$e.length - 1].originalIndex === t[1] - 1;
        }), e.map(function(t) {
            return [
                t[1] - 1,
                t[2]
            ];
        }), e.distinctUntilChanged(ht), e.map(function(t) {
            return t[0];
        }))),
        startReached: e.streamFromEmitter(e.pipe(x, e.throttleTime(200), e.filter(function(t) {
            var _$e = t.items;
            return _$e.length > 0 && _$e[0].originalIndex === t.topItems.length;
        }), e.map(function(t) {
            return t.items[0].index;
        }), e.distinctUntilChanged())),
        rangeChanged: e.streamFromEmitter(e.pipe(x, e.filter(function(t) {
            return t.items.length > 0;
        }), e.map(function(t) {
            var _$e = t.items;
            return {
                startIndex: _$e[0].index,
                endIndex: _$e[_$e.length - 1].index
            };
        }), e.distinctUntilChanged(gt))),
        itemsRendered: w
    }, S);
}, e.tup(nt, pt, It, ct, it, st, ut, x), {
    singleton: !0
}), yt = e.system(function(t) {
    var _$n = t[0], _$r = _$n.sizes, _$o = _$n.firstItemIndex, i = _$n.data, a = t[1].listState, l = t[2].didMount, s = e.statefulStream(0);
    return e.connect(e.pipe(l, e.withLatestFrom(s), e.filter(function(t) {
        return 0 !== t[1];
    }), e.withLatestFrom(_$r, _$o, i), e.map(function(t) {
        var _$e = t[0][1], _$n = t[1], _$r = t[2], _$o = t[3], i = void 0 === _$o ? [] : _$o, a = 0;
        if (_$n.groupIndices.length > 0) for(var l, s = d(_$n.groupIndices); !((l = s()).done || l.value - a >= _$e);)a++;
        var u = _$e + a;
        return wt(Array.from({
            length: u
        }).map(function(t, e) {
            return {
                index: e,
                size: 0,
                offset: 0,
                data: i[e]
            };
        }), [], u, _$n, _$r);
    })), a), {
        initialItemCount: s
    };
}, e.tup(nt, xt, ut), {
    singleton: !0
}), bt = e.system(function(t) {
    var _$n = t[0].scrollVelocity, _$r = e.statefulStream(!1), _$o = e.stream(), i = e.statefulStream(!1);
    return e.connect(e.pipe(_$n, e.withLatestFrom(i, _$r, _$o), e.filter(function(t) {
        return !!t[1];
    }), e.map(function(t) {
        var _$e = t[0], _$n = t[1], _$r = t[2], _$o = t[3], i = _$n.enter;
        if (_$r) {
            if ((0, _$n.exit)(_$e, _$o)) return !1;
        } else if (i(_$e, _$o)) return !0;
        return _$r;
    }), e.distinctUntilChanged()), _$r), e.subscribe(e.pipe(e.combineLatest(_$r, _$n, _$o), e.withLatestFrom(i)), function(t) {
        var _$e = t[0], _$n = t[1];
        return _$e[0] && _$n && _$n.change && _$n.change(_$e[1], _$e[2]);
    }), {
        isSeeking: _$r,
        scrollSeekConfiguration: i,
        scrollVelocity: _$n,
        scrollSeekRangeChanged: _$o
    };
}, e.tup(st), {
    singleton: !0
}), Et = e.system(function(t) {
    var _$n = t[0].topItemsIndexes, _$r = e.statefulStream(0);
    return e.connect(e.pipe(_$r, e.filter(function(t) {
        return t > 0;
    }), e.map(function(t) {
        return Array.from({
            length: t
        }).map(function(t, e) {
            return e;
        });
    })), _$n), {
        topItemCount: _$r
    };
}, e.tup(xt)), Ht = e.system(function(t) {
    var _$n = t[0], _$r = _$n.footerHeight, _$o = _$n.headerHeight, i = _$n.fixedHeaderHeight, a = t[1].listState, l = e.stream(), s = e.statefulStreamFromEmitter(e.pipe(e.combineLatest(_$r, _$o, i, a), e.map(function(t) {
        var _$e = t[3];
        return t[0] + t[1] + t[2] + _$e.offsetBottom + _$e.bottom;
    })), 0);
    return e.connect(e.duc(s), l), {
        totalListHeight: s,
        totalListHeightChanged: l
    };
}, e.tup(y, xt), {
    singleton: !0
});
function Rt(t) {
    var _$e, _$n = !1;
    return function() {
        return _$n || (_$n = !0, _$e = t()), _$e;
    };
}
var Lt = Rt(function() {
    return /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(navigator.userAgent);
}), kt = e.system(function(t) {
    var _$n = t[0], _$r = _$n.scrollBy, _$o = _$n.scrollTop, i = _$n.deviation, a = _$n.scrollingInProgress, l = t[1], s = l.isScrolling, u = l.isAtBottom, c = l.atBottomState, m = l.scrollDirection, d = t[3], f = d.beforeUnshiftWith, h = d.shiftWithOffset, g = d.sizes, v = t[4].log, S = e.streamFromEmitter(e.pipe(t[2].listState, e.withLatestFrom(l.lastJumpDueToItemResize), e.scan(function(t, e) {
        var _$n = t[1], _$r = e[0], _$o = _$r.items, i = _$r.totalCount, a = _$r.bottom + _$r.offsetBottom, l = 0;
        return t[2] === i && _$n.length > 0 && _$o.length > 0 && (0 === _$o[0].originalIndex && 0 === _$n[0].originalIndex || 0 != (l = a - t[3]) && (l += e[1])), [
            l,
            _$o,
            i,
            a
        ];
    }, [
        0,
        [],
        0,
        0
    ]), e.filter(function(t) {
        return 0 !== t[0];
    }), e.withLatestFrom(_$o, m, a, v, u, c), e.filter(function(t) {
        return !t[3] && 0 !== t[1] && t[2] === at;
    }), e.map(function(t) {
        var _$e = t[0][0];
        return (0, t[4])("Upward scrolling compensation", {
            amount: _$e
        }, p.DEBUG), _$e;
    })));
    function I(t) {
        t > 0 ? (e.publish(_$r, {
            top: -t,
            behavior: "auto"
        }), e.publish(i, 0)) : (e.publish(i, 0), e.publish(_$r, {
            top: -t,
            behavior: "auto"
        }));
    }
    return e.subscribe(e.pipe(S, e.withLatestFrom(i, s)), function(t) {
        var _$n = t[0], _$r = t[1];
        t[2] && Lt() ? e.publish(i, _$r - _$n) : I(-_$n);
    }), e.subscribe(e.pipe(e.combineLatest(e.statefulStreamFromEmitter(s, !1), i), e.filter(function(t) {
        return !t[0] && 0 !== t[1];
    }), e.map(function(t) {
        return t[1];
    }), e.throttleTime(1)), I), e.connect(e.pipe(h, e.map(function(t) {
        return {
            top: -t
        };
    })), _$r), e.connect(e.pipe(f, e.withLatestFrom(g), e.map(function(t) {
        return t[0] * t[1].lastSize;
    })), S), {
        deviation: i
    };
}, e.tup(y, st, xt, nt, v)), zt = e.system(function(t) {
    var _$n = t[0].totalListHeight, _$r = t[1].didMount, _$o = t[2].scrollTo, i = e.statefulStream(0);
    return e.subscribe(e.pipe(_$r, e.withLatestFrom(i), e.filter(function(t) {
        return 0 !== t[1];
    }), e.map(function(t) {
        return {
            top: t[1]
        };
    })), function(t) {
        e.handleNext(e.pipe(_$n, e.filter(function(t) {
            return 0 !== t;
        })), function() {
            setTimeout(function() {
                e.publish(_$o, t);
            });
        });
    }), {
        initialScrollTop: i
    };
}, e.tup(Ht, ut, y), {
    singleton: !0
}), Bt = e.system(function(t) {
    var _$n = t[0].viewportHeight, _$r = t[1].totalListHeight, _$o = e.statefulStream(!1);
    return {
        alignToBottom: _$o,
        paddingTopAddition: e.statefulStreamFromEmitter(e.pipe(e.combineLatest(_$o, _$n, _$r), e.filter(function(t) {
            return t[0];
        }), e.map(function(t) {
            return Math.max(0, t[1] - t[2]);
        }), e.distinctUntilChanged()), 0)
    };
}, e.tup(y, Ht), {
    singleton: !0
}), Ft = e.system(function(t) {
    var _$n = t[0], _$r = _$n.scrollTo, _$o = _$n.scrollContainerState, i = e.stream(), a = e.stream(), l = e.stream(), s = e.statefulStream(!1), c = e.statefulStream(void 0);
    return e.connect(e.pipe(e.combineLatest(i, a), e.map(function(t) {
        var _$e = t[0], _$n = _$e.viewportHeight, _$r = _$e.scrollHeight;
        return {
            scrollTop: Math.max(0, _$e.scrollTop - t[1].offsetTop),
            scrollHeight: _$r,
            viewportHeight: _$n
        };
    })), _$o), e.connect(e.pipe(_$r, e.withLatestFrom(a), e.map(function(t) {
        var _$e = t[0];
        return u({}, _$e, {
            top: _$e.top + t[1].offsetTop
        });
    })), l), {
        useWindowScroll: s,
        customScrollParent: c,
        windowScrollContainerState: i,
        windowViewportRect: a,
        windowScrollTo: l
    };
}, e.tup(y)), Pt = [
    "done",
    "behavior"
], Ot = e.system(function(t) {
    var _$n = t[0], _$r = _$n.sizes, _$o = _$n.totalCount, i = t[1], a = i.scrollTop, l = i.viewportHeight, s = i.headerHeight, m = i.scrollingInProgress, d = t[2].scrollToIndex, f = e.stream();
    return e.connect(e.pipe(f, e.withLatestFrom(_$r, l, _$o, s, a), e.map(function(t) {
        var _$n = t[0], _$r = t[1], _$o = t[2], i = t[3], a = t[4], l = t[5], s = _$n.done, d = _$n.behavior, f = c(_$n, Pt), p = null, h = Q(_$n, _$r, i - 1), g = $(h, _$r.offsetTree) + a;
        return g < l ? p = u({}, f, {
            behavior: d,
            align: "start"
        }) : g + k(_$r.sizeTree, h)[1] > l + _$o && (p = u({}, f, {
            behavior: d,
            align: "end"
        })), p ? s && e.handleNext(e.pipe(m, e.skip(1), e.filter(function(t) {
            return !1 === t;
        })), s) : s && s(), p;
    }), e.filter(function(t) {
        return null !== t;
    })), d), {
        scrollIntoView: f
    };
}, e.tup(nt, y, it, xt, v), {
    singleton: !0
}), Mt = [
    "listState",
    "topItemsIndexes"
], Vt = e.system(function(t) {
    return u({}, t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8]);
}, e.tup(It, yt, ut, bt, Ht, zt, Bt, Ft, Ot)), Ut = e.system(function(t) {
    var _$n = t[0], _$r = _$n.totalCount, _$o = _$n.sizeRanges, i = _$n.fixedItemSize, a = _$n.defaultItemSize, l = _$n.trackItemSizes, s = _$n.itemSize, m = _$n.data, d = _$n.firstItemIndex, f = _$n.groupIndices, p = _$n.statefulTotalCount, h = t[1], g = h.initialTopMostItemIndex, v = h.scrolledToInitialItem, S = t[2], I = t[3], C = t[4], T = C.listState, w = C.topItemsIndexes, x = c(C, Mt), y = t[5].scrollToIndex, b = t[7].topItemCount, E = t[8].groupCounts, H = t[9], R = t[10];
    return e.connect(x.rangeChanged, H.scrollSeekRangeChanged), e.connect(e.pipe(H.windowViewportRect, e.map(e.prop("visibleHeight"))), S.viewportHeight), u({
        totalCount: _$r,
        data: m,
        firstItemIndex: d,
        sizeRanges: _$o,
        initialTopMostItemIndex: g,
        scrolledToInitialItem: v,
        topItemsIndexes: w,
        topItemCount: b,
        groupCounts: E,
        fixedItemHeight: i,
        defaultItemHeight: a
    }, I, {
        statefulTotalCount: p,
        listState: T,
        scrollToIndex: y,
        trackItemSizes: l,
        itemSize: s,
        groupIndices: f
    }, x, H, S, R);
}, e.tup(nt, ct, y, dt, xt, it, kt, Et, pt, Vt, v)), At = Rt(function() {
    if ("undefined" == typeof document) return "sticky";
    var _$t = document.createElement("div");
    return _$t.style.position = "-webkit-sticky", "-webkit-sticky" === _$t.style.position ? "-webkit-sticky" : "sticky";
});
function Wt(t, e) {
    var _$n = i(null), _$r = a(function(r) {
        if (null !== r) {
            var _$o, _$i, _$a = r.getBoundingClientRect(), l = _$a.width;
            if (e) {
                var s = e.getBoundingClientRect(), u = _$a.top - s.top;
                _$o = s.height - Math.max(0, u), _$i = u + e.scrollTop;
            } else _$o = window.innerHeight - Math.max(0, _$a.top), _$i = _$a.top + window.pageYOffset;
            _$n.current = {
                offsetTop: _$i,
                visibleHeight: _$o,
                visibleWidth: l
            }, t(_$n.current);
        }
    }, [
        t,
        e
    ]), l = S(_$r), s = l.callbackRef, u = l.ref, c = a(function() {
        _$r(u.current);
    }, [
        _$r,
        u
    ]);
    return o(function() {
        if (e) {
            e.addEventListener("scroll", c);
            var _$t = new ResizeObserver(c);
            return _$t.observe(e), function() {
                e.removeEventListener("scroll", c), _$t.unobserve(e);
            };
        }
        return window.addEventListener("scroll", c), window.addEventListener("resize", c), function() {
            window.removeEventListener("scroll", c), window.removeEventListener("resize", c);
        };
    }, [
        c,
        e
    ]), s;
}
var Nt = [
    "placeholder"
], Dt = [
    "style",
    "children"
], Gt = [
    "style",
    "children"
];
function _t(t) {
    return t;
}
var jt = e.system(function() {
    var _$t = e.statefulStream(function(t) {
        return "Item " + t;
    }), _$n = e.statefulStream(null), _$r = e.statefulStream(function(t) {
        return "Group " + t;
    }), _$o = e.statefulStream({}), i = e.statefulStream(_t), a = e.statefulStream("div"), l = e.statefulStream(e.noop), s = function s(t, n) {
        return void 0 === n && (n = null), e.statefulStreamFromEmitter(e.pipe(_$o, e.map(function(e) {
            return e[t];
        }), e.distinctUntilChanged()), n);
    };
    return {
        context: _$n,
        itemContent: _$t,
        groupContent: _$r,
        components: _$o,
        computeItemKey: i,
        headerFooterTag: a,
        scrollerRef: l,
        FooterComponent: s("Footer"),
        HeaderComponent: s("Header"),
        TopItemListComponent: s("TopItemList"),
        ListComponent: s("List", "div"),
        ItemComponent: s("Item", "div"),
        GroupComponent: s("Group", "div"),
        ScrollerComponent: s("Scroller", "div"),
        EmptyPlaceholder: s("EmptyPlaceholder"),
        ScrollSeekPlaceholder: s("ScrollSeekPlaceholder")
    };
});
function Kt(t, n) {
    var _$r = e.stream();
    return e.subscribe(_$r, function() {
        return console.warn("react-virtuoso: You are using a deprecated property. " + n, "color: red;", "color: inherit;", "color: blue;");
    }), e.connect(_$r, t), _$r;
}
var Yt = e.system(function(t) {
    var _$n = t[0], _$r = t[1], _$o = {
        item: Kt(_$r.itemContent, "Rename the %citem%c prop to %citemContent."),
        group: Kt(_$r.groupContent, "Rename the %cgroup%c prop to %cgroupContent."),
        topItems: Kt(_$n.topItemCount, "Rename the %ctopItems%c prop to %ctopItemCount."),
        itemHeight: Kt(_$n.fixedItemHeight, "Rename the %citemHeight%c prop to %cfixedItemHeight."),
        scrollingStateChange: Kt(_$n.isScrolling, "Rename the %cscrollingStateChange%c prop to %cisScrolling."),
        adjustForPrependedItems: e.stream(),
        maxHeightCacheSize: e.stream(),
        footer: e.stream(),
        header: e.stream(),
        HeaderContainer: e.stream(),
        FooterContainer: e.stream(),
        ItemContainer: e.stream(),
        ScrollContainer: e.stream(),
        GroupContainer: e.stream(),
        ListContainer: e.stream(),
        emptyComponent: e.stream(),
        scrollSeek: e.stream()
    };
    function i(t, n, o) {
        e.connect(e.pipe(t, e.withLatestFrom(_$r.components), e.map(function(t) {
            var _$e, _$r = t[0], _$i = t[1];
            return console.warn("react-virtuoso: " + o + " property is deprecated. Pass components." + n + " instead."), u({}, _$i, ((_$e = {})[n] = _$r, _$e));
        })), _$r.components);
    }
    return e.subscribe(_$o.adjustForPrependedItems, function() {
        console.warn("react-virtuoso: adjustForPrependedItems is no longer supported. Use the firstItemIndex property instead - https://virtuoso.dev/prepend-items.", "color: red;", "color: inherit;", "color: blue;");
    }), e.subscribe(_$o.maxHeightCacheSize, function() {
        console.warn("react-virtuoso: maxHeightCacheSize is no longer necessary. Setting it has no effect - remove it from your code.");
    }), e.subscribe(_$o.HeaderContainer, function() {
        console.warn("react-virtuoso: HeaderContainer is deprecated. Use headerFooterTag if you want to change the wrapper of the header component and pass components.Header to change its contents.");
    }), e.subscribe(_$o.FooterContainer, function() {
        console.warn("react-virtuoso: FooterContainer is deprecated. Use headerFooterTag if you want to change the wrapper of the footer component and pass components.Footer to change its contents.");
    }), e.subscribe(_$o.scrollSeek, function(t) {
        var _$o = t.placeholder, _$i = c(t, Nt);
        console.warn("react-virtuoso: scrollSeek property is deprecated. Pass scrollSeekConfiguration and specify the placeholder in components.ScrollSeekPlaceholder instead."), e.publish(_$r.components, u({}, e.getValue(_$r.components), {
            ScrollSeekPlaceholder: _$o
        })), e.publish(_$n.scrollSeekConfiguration, _$i);
    }), i(_$o.footer, "Footer", "footer"), i(_$o.header, "Header", "header"), i(_$o.ItemContainer, "Item", "ItemContainer"), i(_$o.ListContainer, "List", "ListContainer"), i(_$o.ScrollContainer, "Scroller", "ScrollContainer"), i(_$o.emptyComponent, "EmptyPlaceholder", "emptyComponent"), i(_$o.GroupContainer, "Group", "GroupContainer"), u({}, _$n, _$r, _$o);
}, e.tup(Ut, jt)), Zt = function Zt(t) {
    return n.createElement("div", {
        style: {
            height: t.height
        }
    });
}, qt = {
    position: At(),
    zIndex: 1,
    overflowAnchor: "none"
}, Jt = {
    overflowAnchor: "none"
}, $t = n.memo(function(t) {
    var _$r = t.showTopList, _$o = void 0 !== _$r && _$r, i = de("listState"), a = me("sizeRanges"), s = de("useWindowScroll"), c = de("customScrollParent"), m = me("windowScrollContainerState"), d = me("scrollContainerState"), f = c || s ? m : d, p = de("itemContent"), h = de("context"), g = de("groupContent"), v = de("trackItemSizes"), S = de("itemSize"), I = de("log"), T = C(a, S, v, _$o ? e.noop : f, I, c), w = T.callbackRef, x = T.ref, y = n.useState(0), b = y[0], E = y[1];
    fe("deviation", function(t) {
        b !== t && (x.current.style.marginTop = t + "px", E(t));
    });
    var H = de("EmptyPlaceholder"), R = de("ScrollSeekPlaceholder") || Zt, L = de("ListComponent"), k = de("ItemComponent"), z = de("GroupComponent"), B = de("computeItemKey"), F = de("isSeeking"), P = de("groupIndices").length > 0, O = de("paddingTopAddition"), M = _$o ? {} : {
        boxSizing: "border-box",
        paddingTop: i.offsetTop + O,
        paddingBottom: i.offsetBottom,
        marginTop: b
    };
    return !_$o && 0 === i.totalCount && H ? l(H, ee(H, h)) : l(L, u({}, ee(L, h), {
        ref: w,
        style: M,
        "data-test-id": _$o ? "virtuoso-top-item-list" : "virtuoso-item-list"
    }), (_$o ? i.topItems : i.items).map(function(t) {
        var _$e = t.originalIndex, _$n = B(_$e + i.firstItemIndex, t.data, h);
        return F ? l(R, u({}, ee(R, h), {
            key: _$n,
            index: t.index,
            height: t.size,
            type: t.type || "item"
        }, "group" === t.type ? {} : {
            groupIndex: t.groupIndex
        })) : "group" === t.type ? l(z, u({}, ee(z, h), {
            key: _$n,
            "data-index": _$e,
            "data-known-size": t.size,
            "data-item-index": t.index,
            style: qt
        }), g(t.index)) : l(k, u({}, ee(k, h), {
            key: _$n,
            "data-index": _$e,
            "data-known-size": t.size,
            "data-item-index": t.index,
            "data-item-group-index": t.groupIndex,
            style: Jt
        }), P ? p(t.index, t.groupIndex, t.data, h) : p(t.index, t.data, h));
    }));
}), Qt = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
}, Xt = {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0
}, te = {
    width: "100%",
    position: At(),
    top: 0
};
function ee(t, e) {
    if ("string" != typeof t) return {
        context: e
    };
}
var ne = n.memo(function() {
    var _$t = de("HeaderComponent"), _$e = me("headerHeight"), _$n = de("headerFooterTag"), _$r = I(function(t) {
        return _$e(T(t, "height"));
    }), _$o = de("context");
    return _$t ? l(_$n, {
        ref: _$r
    }, l(_$t, ee(_$t, _$o))) : null;
}), re = n.memo(function() {
    var _$t = de("FooterComponent"), _$e = me("footerHeight"), _$n = de("headerFooterTag"), _$r = I(function(t) {
        return _$e(T(t, "height"));
    }), _$o = de("context");
    return _$t ? l(_$n, {
        ref: _$r
    }, l(_$t, ee(_$t, _$o))) : null;
});
function oe(t) {
    var _$e = t.usePublisher, _$r = t.useEmitter, _$o = t.useEmitterValue;
    return n.memo(function(t) {
        var _$n = t.style, i = t.children, a = c(t, Dt), s = _$e("scrollContainerState"), m = _$o("ScrollerComponent"), d = _$e("smoothScrollTargetReached"), f = _$o("scrollerRef"), p = _$o("context"), h = w(s, d, m, f), g = h.scrollerRef, v = h.scrollByCallback;
        return _$r("scrollTo", h.scrollToCallback), _$r("scrollBy", v), l(m, u({
            ref: g,
            style: u({}, Qt, _$n),
            "data-test-id": "virtuoso-scroller",
            "data-virtuoso-scroller": !0,
            tabIndex: 0
        }, a, ee(m, p)), i);
    });
}
function ie(t) {
    var _$r = t.usePublisher, _$o = t.useEmitter, i = t.useEmitterValue;
    return n.memo(function(t) {
        var _$n = t.style, a = t.children, s = c(t, Gt), m = _$r("windowScrollContainerState"), d = i("ScrollerComponent"), f = _$r("smoothScrollTargetReached"), p = i("totalListHeight"), g = i("deviation"), v = i("customScrollParent"), S = i("context"), I = w(m, f, d, e.noop, v), C = I.scrollerRef, T = I.scrollByCallback, x = I.scrollToCallback;
        return h(function() {
            return C.current = v || window, function() {
                C.current = null;
            };
        }, [
            C,
            v
        ]), _$o("windowScrollTo", x), _$o("scrollBy", T), l(d, u({
            style: u({
                position: "relative"
            }, _$n, 0 !== p ? {
                height: p + g
            } : {}),
            "data-virtuoso-scroller": !0
        }, s, ee(d, S)), a);
    });
}
var ae = function ae(t) {
    var _$r = t.children, _$o = me("viewportHeight"), i = I(e.compose(_$o, function(t) {
        return T(t, "height");
    }));
    return n.createElement("div", {
        style: Xt,
        ref: i,
        "data-viewport-type": "element"
    }, _$r);
}, le = function le(t) {
    var _$e = t.children, _$r = Wt(me("windowViewportRect"), de("customScrollParent"));
    return n.createElement("div", {
        ref: _$r,
        style: Xt,
        "data-viewport-type": "window"
    }, _$e);
}, se = function se(t) {
    var _$e = t.children, _$n = de("TopItemListComponent"), _$r = de("headerHeight"), _$o = u({}, te, {
        marginTop: _$r + "px"
    }), i = de("context");
    return l(_$n || "div", {
        style: _$o,
        context: i
    }, _$e);
}, ue = t(Yt, {
    required: {},
    optional: {
        context: "context",
        followOutput: "followOutput",
        firstItemIndex: "firstItemIndex",
        itemContent: "itemContent",
        groupContent: "groupContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        topItemCount: "topItemCount",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        groupCounts: "groupCounts",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        headerFooterTag: "headerFooterTag",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        react18ConcurrentRendering: "react18ConcurrentRendering",
        item: "item",
        group: "group",
        topItems: "topItems",
        itemHeight: "itemHeight",
        scrollingStateChange: "scrollingStateChange",
        maxHeightCacheSize: "maxHeightCacheSize",
        footer: "footer",
        header: "header",
        ItemContainer: "ItemContainer",
        ScrollContainer: "ScrollContainer",
        ListContainer: "ListContainer",
        GroupContainer: "GroupContainer",
        emptyComponent: "emptyComponent",
        HeaderContainer: "HeaderContainer",
        FooterContainer: "FooterContainer",
        scrollSeek: "scrollSeek"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        adjustForPrependedItems: "adjustForPrependedItems"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, n.memo(function(t) {
    var _$e = de("useWindowScroll"), _$r = de("topItemsIndexes").length > 0, _$o = de("customScrollParent"), i = _$o || _$e ? le : ae;
    return n.createElement(_$o || _$e ? he : pe, u({}, t), n.createElement(i, null, n.createElement(ne, null), n.createElement($t, null), n.createElement(re, null)), _$r && n.createElement(se, null, n.createElement($t, {
        showTopList: !0
    })));
})), ce = ue.Component, me = ue.usePublisher, de = ue.useEmitterValue, fe = ue.useEmitter, pe = oe({
    usePublisher: me,
    useEmitterValue: de,
    useEmitter: fe
}), he = ie({
    usePublisher: me,
    useEmitterValue: de,
    useEmitter: fe
}), ge = {
    items: [],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
}, ve = {
    items: [
        {
            index: 0
        }
    ],
    offsetBottom: 0,
    offsetTop: 0,
    top: 0,
    bottom: 0,
    itemHeight: 0,
    itemWidth: 0
}, Se = Math.round, Ie = Math.ceil, Ce = Math.floor, Te = Math.min, we = Math.max;
function xe(t, e) {
    return Array.from({
        length: e - t + 1
    }).map(function(e, n) {
        return {
            index: n + t
        };
    });
}
var ye = e.system(function(t) {
    var _$n = t[0], _$r = _$n.overscan, _$o = _$n.visibleRange, i = _$n.listBoundary, a = t[1], l = a.scrollTop, s = a.viewportHeight, c = a.scrollBy, m = a.scrollTo, d = a.smoothScrollTargetReached, f = a.scrollContainerState, p = t[2], h = t[3], g = t[4], v = g.propsReady, S = g.didMount, I = t[5], C = I.windowViewportRect, T = I.windowScrollTo, w = I.useWindowScroll, x = I.customScrollParent, y = I.windowScrollContainerState, b = e.statefulStream(0), E = e.statefulStream(0), H = e.statefulStream(ge), R = e.statefulStream({
        height: 0,
        width: 0
    }), L = e.statefulStream({
        height: 0,
        width: 0
    }), k = e.stream(), z = e.stream(), B = e.statefulStream(0);
    e.connect(e.pipe(S, e.withLatestFrom(E), e.filter(function(t) {
        return 0 !== t[1];
    }), e.map(function(t) {
        return {
            items: xe(0, t[1] - 1),
            top: 0,
            bottom: 0,
            offsetBottom: 0,
            offsetTop: 0,
            itemHeight: 0,
            itemWidth: 0
        };
    })), H), e.connect(e.pipe(e.combineLatest(e.duc(b), _$o, e.duc(L, function(t, e) {
        return t && t.width === e.width && t.height === e.height;
    })), e.withLatestFrom(R), e.map(function(t) {
        var _$e = t[0], _$n = _$e[0], _$r = _$e[1], _$o = _$r[0], i = _$r[1], a = _$e[2], l = t[1], s = a.height, _$u = a.width, c = l.width;
        if (0 === _$n || 0 === c) return ge;
        if (0 === _$u) return ve;
        var m = He(c, _$u), d = m * Ce(_$o / s), f = m * Ie(i / s) - 1;
        f = we(0, Te(_$n - 1, f));
        var p = xe(d = Te(f, we(0, d)), f), h = be(l, a, p), g = h.top, v = h.bottom;
        return {
            items: p,
            offsetTop: g,
            offsetBottom: Ie(_$n / m) * s - v,
            top: g,
            bottom: v,
            itemHeight: s,
            itemWidth: _$u
        };
    })), H), e.connect(e.pipe(R, e.map(function(t) {
        return t.height;
    })), s), e.connect(e.pipe(e.combineLatest(R, L, H), e.map(function(t) {
        var _$e = be(t[0], t[1], t[2].items);
        return [
            _$e.top,
            _$e.bottom
        ];
    }), e.distinctUntilChanged(ht)), i);
    var F = e.streamFromEmitter(e.pipe(e.duc(H), e.filter(function(t) {
        return t.items.length > 0;
    }), e.withLatestFrom(b), e.filter(function(t) {
        var _$e = t[0].items;
        return _$e[_$e.length - 1].index === t[1] - 1;
    }), e.map(function(t) {
        return t[1] - 1;
    }), e.distinctUntilChanged())), P = e.streamFromEmitter(e.pipe(e.duc(H), e.filter(function(t) {
        var _$e = t.items;
        return _$e.length > 0 && 0 === _$e[0].index;
    }), e.mapTo(0), e.distinctUntilChanged())), O = e.streamFromEmitter(e.pipe(e.duc(H), e.filter(function(t) {
        return t.items.length > 0;
    }), e.map(function(t) {
        var _$e = t.items;
        return {
            startIndex: _$e[0].index,
            endIndex: _$e[_$e.length - 1].index
        };
    }), e.distinctUntilChanged(gt)));
    e.connect(O, h.scrollSeekRangeChanged), e.connect(e.pipe(k, e.withLatestFrom(R, L, b), e.map(function(t) {
        var _$e = t[1], _$n = t[2], _$r = t[3], _$o = ot(t[0]), i = _$o.align, a = _$o.behavior, l = _$o.offset, s = _$o.index;
        "LAST" === s && (s = _$r - 1);
        var _$u = Ee(_$e, _$n, s = we(0, s, Te(_$r - 1, s)));
        return "end" === i ? _$u = Se(_$u - _$e.height + _$n.height) : "center" === i && (_$u = Se(_$u - _$e.height / 2 + _$n.height / 2)), l && (_$u += l), {
            top: _$u,
            behavior: a
        };
    })), m);
    var M = e.statefulStreamFromEmitter(e.pipe(H, e.map(function(t) {
        return t.offsetBottom + t.bottom;
    })), 0);
    return e.connect(e.pipe(C, e.map(function(t) {
        return {
            width: t.visibleWidth,
            height: t.visibleHeight
        };
    })), R), u({
        totalCount: b,
        viewportDimensions: R,
        itemDimensions: L,
        scrollTop: l,
        scrollHeight: z,
        overscan: _$r,
        scrollBy: c,
        scrollTo: m,
        scrollToIndex: k,
        smoothScrollTargetReached: d,
        windowViewportRect: C,
        windowScrollTo: T,
        useWindowScroll: w,
        customScrollParent: x,
        windowScrollContainerState: y,
        deviation: B,
        scrollContainerState: f,
        initialItemCount: E
    }, h, {
        gridState: H,
        totalListHeight: M
    }, p, {
        startReached: P,
        endReached: F,
        rangeChanged: O,
        propsReady: v
    });
}, e.tup(It, y, st, bt, ut, Ft));
function be(t, e, n) {
    var _$r = e.height;
    return void 0 === _$r || 0 === n.length ? {
        top: 0,
        bottom: 0
    } : {
        top: Ee(t, e, n[0].index),
        bottom: Ee(t, e, n[n.length - 1].index) + _$r
    };
}
function Ee(t, e, n) {
    var _$r = He(t.width, e.width);
    return Ce(n / _$r) * e.height;
}
function He(t, e) {
    return we(1, Ce(t / e));
}
var Re = [
    "placeholder"
], Le = e.system(function() {
    var _$t = e.statefulStream(function(t) {
        return "Item " + t;
    }), _$n = e.statefulStream({}), _$r = e.statefulStream(null), _$o = e.statefulStream("virtuoso-grid-item"), i = e.statefulStream("virtuoso-grid-list"), a = e.statefulStream(_t), l = e.statefulStream(e.noop), s = function s(t, r) {
        return void 0 === r && (r = null), e.statefulStreamFromEmitter(e.pipe(_$n, e.map(function(e) {
            return e[t];
        }), e.distinctUntilChanged()), r);
    };
    return {
        context: _$r,
        itemContent: _$t,
        components: _$n,
        computeItemKey: a,
        itemClassName: _$o,
        listClassName: i,
        scrollerRef: l,
        ListComponent: s("List", "div"),
        ItemComponent: s("Item", "div"),
        ScrollerComponent: s("Scroller", "div"),
        ScrollSeekPlaceholder: s("ScrollSeekPlaceholder", "div")
    };
}), ke = e.system(function(t) {
    var _$n = t[0], _$r = t[1], _$o = {
        item: Kt(_$r.itemContent, "Rename the %citem%c prop to %citemContent."),
        ItemContainer: e.stream(),
        ScrollContainer: e.stream(),
        ListContainer: e.stream(),
        emptyComponent: e.stream(),
        scrollSeek: e.stream()
    };
    function i(t, n, o) {
        e.connect(e.pipe(t, e.withLatestFrom(_$r.components), e.map(function(t) {
            var _$e, _$r = t[0], _$i = t[1];
            return console.warn("react-virtuoso: " + o + " property is deprecated. Pass components." + n + " instead."), u({}, _$i, ((_$e = {})[n] = _$r, _$e));
        })), _$r.components);
    }
    return e.subscribe(_$o.scrollSeek, function(t) {
        var _$o = t.placeholder, _$i = c(t, Re);
        console.warn("react-virtuoso: scrollSeek property is deprecated. Pass scrollSeekConfiguration and specify the placeholder in components.ScrollSeekPlaceholder instead."), e.publish(_$r.components, u({}, e.getValue(_$r.components), {
            ScrollSeekPlaceholder: _$o
        })), e.publish(_$n.scrollSeekConfiguration, _$i);
    }), i(_$o.ItemContainer, "Item", "ItemContainer"), i(_$o.ListContainer, "List", "ListContainer"), i(_$o.ScrollContainer, "Scroller", "ScrollContainer"), u({}, _$n, _$r, _$o);
}, e.tup(ye, Le)), ze = n.memo(function() {
    var _$t = Ve("gridState"), _$e = Ve("listClassName"), _$n = Ve("itemClassName"), _$r = Ve("itemContent"), _$o = Ve("computeItemKey"), i = Ve("isSeeking"), a = Me("scrollHeight"), s = Ve("ItemComponent"), c = Ve("ListComponent"), m = Ve("ScrollSeekPlaceholder"), d = Ve("context"), f = Me("itemDimensions"), p = I(function(t) {
        a(t.parentElement.parentElement.scrollHeight);
        var _$e = t.firstChild;
        _$e && f(_$e.getBoundingClientRect());
    });
    return l(c, u({
        ref: p,
        className: _$e
    }, ee(c, d), {
        style: {
            paddingTop: _$t.offsetTop,
            paddingBottom: _$t.offsetBottom
        }
    }), _$t.items.map(function(e) {
        var a = _$o(e.index);
        return i ? l(m, u({
            key: a
        }, ee(m, d), {
            index: e.index,
            height: _$t.itemHeight,
            width: _$t.itemWidth
        })) : l(s, u({}, ee(s, d), {
            className: _$n,
            "data-index": e.index,
            key: a
        }), _$r(e.index, d));
    }));
}), Be = function Be(t) {
    var _$e = t.children, _$r = Me("viewportDimensions"), _$o = I(function(t) {
        _$r(t.getBoundingClientRect());
    });
    return n.createElement("div", {
        style: Xt,
        ref: _$o
    }, _$e);
}, Fe = function Fe(t) {
    var _$e = t.children, _$r = Wt(Me("windowViewportRect"), Ve("customScrollParent"));
    return n.createElement("div", {
        ref: _$r,
        style: Xt
    }, _$e);
}, Pe = t(ke, {
    optional: {
        totalCount: "totalCount",
        overscan: "overscan",
        itemContent: "itemContent",
        components: "components",
        computeItemKey: "computeItemKey",
        initialItemCount: "initialItemCount",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        listClassName: "listClassName",
        itemClassName: "itemClassName",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        item: "item",
        ItemContainer: "ItemContainer",
        ScrollContainer: "ScrollContainer",
        ListContainer: "ListContainer",
        scrollSeek: "scrollSeek"
    },
    methods: {
        scrollTo: "scrollTo",
        scrollBy: "scrollBy",
        scrollToIndex: "scrollToIndex"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange"
    }
}, n.memo(function(t) {
    var _$e = u({}, t), _$r = Ve("useWindowScroll"), _$o = Ve("customScrollParent"), i = _$o || _$r ? Fe : Be;
    return n.createElement(_$o || _$r ? We : Ae, u({}, _$e), n.createElement(i, null, n.createElement(ze, null)));
})), Oe = Pe.Component, Me = Pe.usePublisher, Ve = Pe.useEmitterValue, Ue = Pe.useEmitter, Ae = oe({
    usePublisher: Me,
    useEmitterValue: Ve,
    useEmitter: Ue
}), We = ie({
    usePublisher: Me,
    useEmitterValue: Ve,
    useEmitter: Ue
}), Ne = e.system(function() {
    var _$t = e.statefulStream(function(t) {
        return n.createElement("td", null, "Item $", t);
    }), _$r = e.statefulStream(null), _$o = e.statefulStream(null), i = e.statefulStream({}), a = e.statefulStream(_t), l = e.statefulStream(e.noop), s = function s(t, n) {
        return void 0 === n && (n = null), e.statefulStreamFromEmitter(e.pipe(i, e.map(function(e) {
            return e[t];
        }), e.distinctUntilChanged()), n);
    };
    return {
        context: _$r,
        itemContent: _$t,
        fixedHeaderContent: _$o,
        components: i,
        computeItemKey: a,
        scrollerRef: l,
        TableComponent: s("Table", "table"),
        TableHeadComponent: s("TableHead", "thead"),
        TableBodyComponent: s("TableBody", "tbody"),
        TableRowComponent: s("TableRow", "tr"),
        ScrollerComponent: s("Scroller", "div"),
        EmptyPlaceholder: s("EmptyPlaceholder"),
        ScrollSeekPlaceholder: s("ScrollSeekPlaceholder"),
        FillerRow: s("FillerRow")
    };
}), De = e.system(function(t) {
    return u({}, t[0], t[1]);
}, e.tup(Ut, Ne)), Ge = function Ge(t) {
    return n.createElement("tr", null, n.createElement("td", {
        style: {
            height: t.height
        }
    }));
}, _e = function _e(t) {
    return n.createElement("tr", null, n.createElement("td", {
        style: {
            height: t.height,
            padding: 0,
            border: 0
        }
    }));
}, je = n.memo(function() {
    var _$t = $e("listState"), _$e = Je("sizeRanges"), _$r = $e("useWindowScroll"), _$o = $e("customScrollParent"), i = Je("windowScrollContainerState"), a = Je("scrollContainerState"), s = _$o || _$r ? i : a, c = $e("itemContent"), m = $e("trackItemSizes"), d = C(_$e, $e("itemSize"), m, s, $e("log"), _$o), f = d.callbackRef, p = d.ref, h = n.useState(0), g = h[0], v = h[1];
    Qe("deviation", function(t) {
        g !== t && (p.current.style.marginTop = t + "px", v(t));
    });
    var S = $e("EmptyPlaceholder"), I = $e("ScrollSeekPlaceholder") || Ge, T = $e("FillerRow") || _e, w = $e("TableBodyComponent"), x = $e("TableRowComponent"), y = $e("computeItemKey"), b = $e("isSeeking"), E = $e("paddingTopAddition"), H = $e("firstItemIndex"), R = $e("statefulTotalCount"), L = $e("context");
    if (0 === R && S) return l(S, ee(S, L));
    var k = _$t.offsetTop + E + g, z = _$t.offsetBottom, B = k > 0 ? n.createElement(T, {
        height: k,
        key: "padding-top"
    }) : null, F = z > 0 ? n.createElement(T, {
        height: z,
        key: "padding-bottom"
    }) : null, P = _$t.items.map(function(t) {
        var _$e = t.originalIndex, _$n = y(_$e + H, t.data, L);
        return b ? l(I, u({}, ee(I, L), {
            key: _$n,
            index: t.index,
            height: t.size,
            type: t.type || "item"
        })) : l(x, u({}, ee(x, L), {
            key: _$n,
            "data-index": _$e,
            "data-known-size": t.size,
            "data-item-index": t.index,
            style: {
                overflowAnchor: "none"
            }
        }), c(t.index, t.data, L));
    });
    return l(w, u({
        ref: f,
        "data-test-id": "virtuoso-item-list"
    }, ee(w, L)), [
        B
    ].concat(P, [
        F
    ]));
}), Ke = function Ke(t) {
    var _$r = t.children, _$o = Je("viewportHeight"), i = I(e.compose(_$o, function(t) {
        return T(t, "height");
    }));
    return n.createElement("div", {
        style: Xt,
        ref: i,
        "data-viewport-type": "element"
    }, _$r);
}, Ye = function Ye(t) {
    var _$e = t.children, _$r = Wt(Je("windowViewportRect"), $e("customScrollParent"));
    return n.createElement("div", {
        ref: _$r,
        style: Xt,
        "data-viewport-type": "window"
    }, _$e);
}, Ze = t(De, {
    required: {},
    optional: {
        context: "context",
        followOutput: "followOutput",
        firstItemIndex: "firstItemIndex",
        itemContent: "itemContent",
        fixedHeaderContent: "fixedHeaderContent",
        overscan: "overscan",
        increaseViewportBy: "increaseViewportBy",
        totalCount: "totalCount",
        topItemCount: "topItemCount",
        initialTopMostItemIndex: "initialTopMostItemIndex",
        components: "components",
        groupCounts: "groupCounts",
        atBottomThreshold: "atBottomThreshold",
        atTopThreshold: "atTopThreshold",
        computeItemKey: "computeItemKey",
        defaultItemHeight: "defaultItemHeight",
        fixedItemHeight: "fixedItemHeight",
        itemSize: "itemSize",
        scrollSeekConfiguration: "scrollSeekConfiguration",
        data: "data",
        initialItemCount: "initialItemCount",
        initialScrollTop: "initialScrollTop",
        alignToBottom: "alignToBottom",
        useWindowScroll: "useWindowScroll",
        customScrollParent: "customScrollParent",
        scrollerRef: "scrollerRef",
        logLevel: "logLevel",
        react18ConcurrentRendering: "react18ConcurrentRendering"
    },
    methods: {
        scrollToIndex: "scrollToIndex",
        scrollIntoView: "scrollIntoView",
        scrollTo: "scrollTo",
        scrollBy: "scrollBy"
    },
    events: {
        isScrolling: "isScrolling",
        endReached: "endReached",
        startReached: "startReached",
        rangeChanged: "rangeChanged",
        atBottomStateChange: "atBottomStateChange",
        atTopStateChange: "atTopStateChange",
        totalListHeightChanged: "totalListHeightChanged",
        itemsRendered: "itemsRendered",
        groupIndices: "groupIndices"
    }
}, n.memo(function(t) {
    var _$r = $e("useWindowScroll"), _$o = $e("customScrollParent"), i = Je("fixedHeaderHeight"), a = $e("fixedHeaderContent"), l = $e("context"), s = I(e.compose(i, function(t) {
        return T(t, "height");
    })), c = _$o || _$r ? tn : Xe, m = _$o || _$r ? Ye : Ke, d = $e("TableComponent"), f = $e("TableHeadComponent"), p = a ? n.createElement(f, u({
        key: "TableHead",
        style: {
            zIndex: 1,
            position: "sticky",
            top: 0
        },
        ref: s
    }, ee(f, l)), a()) : null;
    return n.createElement(c, u({}, t), n.createElement(m, null, n.createElement(d, u({
        style: {
            borderSpacing: 0
        }
    }, ee(d, l)), [
        p,
        n.createElement(je, {
            key: "TableBody"
        })
    ])));
})), qe = Ze.Component, Je = Ze.usePublisher, $e = Ze.useEmitterValue, Qe = Ze.useEmitter, Xe = oe({
    usePublisher: Je,
    useEmitterValue: $e,
    useEmitter: Qe
}), tn = ie({
    usePublisher: Je,
    useEmitterValue: $e,
    useEmitter: Qe
}), en = ce, nn = ce, rn = qe, on = Oe;
export { nn as GroupedVirtuoso, p as LogLevel, rn as TableVirtuoso, en as Virtuoso, on as VirtuosoGrid }; //# sourceMappingURL=index.m.js.map
